import { useEffect, useState } from 'react'

export const PhantomModal = ({
    showModal,
    setShowModal,
    modalContent,
    setModalContent,
    handleCloseModal,
    maxIndex,
    phantomModalContents,
}) => {
    const content = Array.isArray(modalContent.content) ? modalContent.content : []
    const handlePrev = () => {
        setModalContent((prevState) => {
            const newIndex = prevState.index - 1
            return {
                ...prevState,
                index: newIndex,
                content: phantomModalContents[newIndex - 1]?.content || [],
            }
        })
    }

    const handleNext = () => {
        setModalContent((prevState) => {
            const newIndex = prevState.index + 1
            return {
                ...prevState,
                index: newIndex,
                content: phantomModalContents[newIndex - 1]?.content || [],
            }
        })
    }

    const [showSS, setShowSS] = useState(false)

    return (
        showModal && (
            <div
                className={`z-50 w-full fixed overflow-y-auto top-0 left-0 h-full bg-black/80 ${
                    showModal ? 'block' : 'hidden'
                }`}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    className='mx-auto absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-30 w-[95%] max-w-[1280px] max-h-[calc(100vh-100px)] my-12 pb-12'
                >
                    {showSS ? (
                        <div className='relative w-full max-w-[1000px] mx-auto'>
                            <img
                                className='w-full border-0'
                                src={`${process.env.PUBLIC_URL}/images/characters/phantoms/ss-char-phantoms-${modalContent.index}.webp`}
                                alt='game screenshot'
                            />
                            <button
                                onClick={() => setShowSS(false)}
                                className='absolute top-0 right-16 p-2 translate-x-full -translate-y-full'
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />
                            </button>
                        </div>
                    ) : (
                        <div className='flex flex-row items-center md:gap-4 mx-auto justify-center'>
                            <div>
                                <button onClick={handlePrev} disabled={modalContent.index <= 1}>
                                    <img
                                        className={`w-[30px] min-w-[30px] max-w-[30px] ${
                                            modalContent.index <= 1 ? 'brightness-50' : ''
                                        }`}
                                        src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                        alt='prev'
                                    />
                                </button>
                            </div>
                            <div className='relative'>
                                <button
                                    onClick={handleCloseModal}
                                    className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full'
                                >
                                    <img className='' src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />{' '}
                                </button>
                                <div className='bg-char-phantoms w-full max-w-[1280px]'>
                                    <div className='w-full md:w-1/2'>
                                        <img
                                            className={`mx-auto md:mr-auto cursor-pointer px-4 md:px-0 pt-8 md:pl-8`}
                                            src={`${process.env.PUBLIC_URL}/images/characters/phantoms/char-name-phantom-fr-${modalContent.index}.webp`}
                                            alt='phantom name'
                                        />{' '}
                                    </div>
                                    <div className='flex flex-col-reverse md:flex-row px-8 pb-4 items-center'>
                                        <div className='w-full'>
                                            <div className='text-center md:text-left md:pt-4 justify-center  px-4 md:px-8 relative w-full mx-auto'>
                                                <ol className='font-kiwi text-pbbrown text-shadow-white font-bold text-sub md:text-caption list-disc list-outside'>
                                                    {content.map((item, index) => (
                                                        <li className='mt-4 ' key={index}>
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ol>{' '}
                                                <img
                                                    onClick={() => setShowSS(true)}
                                                    className='mt-8 ss-thumb max-w-[480px] w-full md:w-4/5 mx-auto'
                                                    src={`${process.env.PUBLIC_URL}/images/characters/phantoms/ss-char-phantoms-${modalContent.index}.webp`}
                                                    alt='game screenshot'
                                                />{' '}
                                            </div>
                                        </div>{' '}
                                        <div className='md:w-full'>
                                            <img
                                                // onClick={() => {
                                                //     handleOpenModal(i + 1)
                                                // }}
                                                className='mt-8 w-full max-w-[500px]'
                                                src={`${process.env.PUBLIC_URL}/images/characters/phantoms/chr_visual_${modalContent.index}.png`}
                                                alt='game screenshot'
                                            />{' '}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button onClick={handleNext} disabled={modalContent.index >= maxIndex}>
                                <img
                                    className={`w-[30px] min-w-[30px] max-w-[30px] ${
                                        modalContent.index >= maxIndex ? 'brightness-50' : ''
                                    }`}
                                    src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                    alt='next'
                                />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        )
    )
}
